<template>
	<v-fade-transition mode='out-in'>
		<div class='transition-wrapper' :key='`Page-${currentPage}`'>
			<slot name='page' :entries='pageNumberToEntriesMap[currentPage] || []'>
				Provide your template.
			</slot>
		</div>
	</v-fade-transition>
</template>

<script>
import chunk from 'lodash/chunk';

export default {
	name: 'LotteryResultAutoDisplay',
	props: {
		generalInformation: {
			type: Object,
			required: true
		},
		entriesPerPage: {
			type: Number,
			required: true
		},
		timeToShowEachPage: {
			type: Number,
			default: 5000
		}
	},
	created() {
		this.interval = setInterval(() => {
			const lastPage = Object.keys(this.pageNumberToEntriesMap).length,
				nextPage = this.currentPage + 1;
			if (nextPage === lastPage) {
				this.currentPage = 0;
			} else {
				this.currentPage = this.currentPage + 1;
			}
		}, this.timeToShowEachPage);
	},
	destroyed() {
		clearInterval(this.interval);
	},
	data() {
		return {
			interval: null,
			currentPage: 0,
			pageNumberToEntriesMap: {}
		};
	},
	watch: {
		'generalInformation.lotteriesResultsEntries': {
			handler(entries) {
				Object.keys(this.pageNumberToEntriesMap).
					forEach(key => {
						this.$delete(this.pageNumberToEntriesMap, key);
					});
				chunk(entries, this.entriesPerPage).
					forEach((entries, index) => {
						this.$set(this.pageNumberToEntriesMap, index, entries);
					});
			},
			immediate: true
		}
	}
};
</script>

<style scoped>

</style>
